import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';

const containedSubMenus = document.querySelectorAll(
	'.block-navigation-submenu.is-style-contained'
);
const navigationBackButtons = document.querySelectorAll(
	'.block-navigation-submenu__back-button'
);

const clickNavigationBackButton = (e) => {
	const currentNavigationBackButton = e.currentTarget;
	const navigationLink = currentNavigationBackButton.closest(
		'.block-navigation-link'
	);

	if (!navigationLink) {
		return;
	}

	navigationLink.classList.remove('active');

	const closeEvent = new CustomEvent('navigation-submenu-closed', {
		detail: {
			currentElement: navigationLink,
			submenuOpen: false,
		},
	});

	window.dispatchEvent(closeEvent);
};

const setMenuOffset = () => {
	if (0 === containedSubMenus.length) {
		return;
	}

	containedSubMenus.forEach((containedSubMenu) => {
		containedSubMenu.classList.add(
			'block-navigation-submenu--calculating-offset'
		);

		let currentOffsetRem =
			containedSubMenu.style.getPropertyValue('--submenuOffset');

		if (!currentOffsetRem) {
			currentOffsetRem = '0rem';
		}

		const currentOffset =
			currentOffsetRem && currentOffsetRem.endsWith('rem')
				? parseFloat(currentOffsetRem) * getRemBase()
				: 0;

		const button = containedSubMenu.parentElement.querySelector(
			'.block-navigation-link__button'
		);

		const containedSubMenuRect = containedSubMenu.getBoundingClientRect();
		const buttonRect = button.getBoundingClientRect();

		const containedSubMenuLeft = containedSubMenuRect.x - currentOffset;
		const containedSubMenuRight =
			containedSubMenuRect.x - currentOffset + containedSubMenuRect.width;
		const containedSubMenuCenter =
			containedSubMenuLeft + containedSubMenuRect.width / 2;
		const buttonLeft = buttonRect.x;
		const buttonCenter = buttonLeft + buttonRect.width / 2;

		const navigationBlock = containedSubMenu.closest(
			'.block-navigation__container'
		);
		let navigationBlockWidth = window.innerWidth;

		if (navigationBlock) {
			const navigationBlockStyles =
				window.getComputedStyle(navigationBlock);
			navigationBlockWidth =
				navigationBlock.offsetWidth -
				parseFloat(navigationBlockStyles['padding-left']) -
				parseFloat(navigationBlockStyles['padding-right']);
		}

		const containerLeft = (window.innerWidth - navigationBlockWidth) / 2;
		const containerRight = containerLeft + navigationBlockWidth;
		let offset = 0;

		if (containedSubMenuLeft < containerLeft) {
			// offset = containerLeft - containedSubMenuLeft;
		} else if (containedSubMenuRight > containerRight) {
			// offset = containerRight - containedSubMenuRight;
		}

		if (buttonCenter + containedSubMenuRect.width / 2 > containerRight) {
			offset = containerRight - containedSubMenuRight;
		} else if (
			buttonCenter - containedSubMenuRect.width / 2 <
			containerLeft
		) {
			offset = containerLeft - containedSubMenuLeft;
		} else {
			offset = buttonCenter - containedSubMenuCenter;
		}

		containedSubMenu.style.setProperty(
			'--submenuOffset',
			`${offset / getRemBase()}rem`
		);

		if (
			!containedSubMenu.classList.contains(
				'block-navigation-submenu--initialized'
			)
		) {
			containedSubMenu.classList.add(
				'block-navigation-submenu--initialized'
			);
		}

		containedSubMenu.classList.remove(
			'block-navigation-submenu--calculating-offset'
		);
	});
};

if (navigationBackButtons.length > 0) {
	navigationBackButtons.forEach((navigationBackButton) => {
		navigationBackButton.addEventListener(
			'click',
			clickNavigationBackButton
		);
	});
}

setMenuOffset();

window.addEventListener('navigation-submenu-opened', setMenuOffset);
window.addEventListener('resize', throttle(setMenuOffset, 100));
window.addEventListener('load', setMenuOffset);
